import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    event.preventDefault()

    const button = event.currentTarget
    const targetId = button.getAttribute("commandfor")
    console.log('targetid = ' + targetId)
    const target = this.element.querySelector(`[data-dropdown-id="${targetId}"]`)
    console.log('target = ' + target)

    if (!target) return

    if (target.classList.contains("hidden")) {
      this.open(target)
    } else {
      this.close(target)
    }
  }

  open(target) {
    target.classList.remove("hidden")
    target.classList.add("transition", "ease-out", "duration-100", "transform", "opacity-0", "scale-95")

    requestAnimationFrame(() => {
      target.classList.remove("opacity-0", "scale-95")
      target.classList.add("opacity-100", "scale-100")
    })
  }

  close(target) {
    target.classList.remove("opacity-100", "scale-100")
    target.classList.add("ease-in", "duration-75", "opacity-0", "scale-95")

    setTimeout(() => {
      target.classList.add("hidden")
      target.classList.remove("transition", "ease-in", "duration-75", "transform")
    }, 75)
  }

  closeIfOutside(event) {
    if (!this.element.contains(event.target)) {
      const openMenus = this.element.querySelectorAll(`[data-dropdown-id]:not(.hidden)`)
      openMenus.forEach(menu => this.close(menu))
    }
  }
}
